export type AccountReliabilityStatus = 'unknown' | 'ok' | 'low';

export type AccountReliabilityInput = {
  status?: AccountReliabilityStatus | string | null;
  score?: number | null;
} | null | undefined;

export type AccountReliabilityDisplay =
  | { kind: 'blank' }
  | { kind: 'score'; score: number }
  | { kind: 'warning'; score: number };

export function resolveAccountReliabilityDisplay(
  reliability: AccountReliabilityInput,
): AccountReliabilityDisplay {
  if (!reliability || reliability.status === 'unknown' || reliability.status == null) {
    return { kind: 'blank' };
  }
  if (typeof reliability.score !== 'number' || !Number.isFinite(reliability.score)) {
    return { kind: 'blank' };
  }
  if (reliability.status === 'low') {
    return { kind: 'warning', score: reliability.score };
  }
  if (reliability.status === 'ok') {
    return { kind: 'score', score: reliability.score };
  }
  return { kind: 'blank' };
}
